import type { AttentionCardAppointmentCaseModel } from '@components/attention_card/_attention_card.controller';
import { I18nAndL10n } from '@modules/i18n_and_l10n/mod';
import { withTranslation } from '@modules/i18n_and_l10n/with_translation';
import { AttentionCardCaseCardAppointment } from './_attention_card_case_card_appointment.component';
import { getAppointmentParticipantsText } from './_get_appointment_participant_text';

interface Props {
	case: AttentionCardAppointmentCaseModel;
}

export function AttentionCardTypeCurrentAppointment({ case: $case }: Props): JSX.Element {
	const participantsText = getAppointmentParticipantsText($case);

	const ariaLabel = I18nAndL10n.translate('PW.Component.AttentionCard.CurrentAppointment.Aria', {
		participants: participantsText,
		unitName: $case.receptionName,
	});

	return (
		<AttentionCardCaseCardAppointment
			alertive
			case={$case}
			description={withTranslation('PW.Component.AttentionCard.CurrentAppointment.Description')}
			analyticAction='Clicked Go to lobby-card'
			ariaLabel={ariaLabel}
		/>
	);
}
